import React, { ReactNode } from "react"
import Button from "@kiwicom/orbit-components/lib/Button"

import { FormattedMessage } from "react-intl"

type Props = {
  onClose: () => void
  children: ReactNode
}

const Modal = ({ onClose, children }: Props) => (
  <div className="InfoModal">
    <div className="InfoModal-text">{children}</div>
    <div className="InfoModal-actions">
      <Button onClick={onClose} fullWidth>
        <FormattedMessage id="common.ok" defaultMessage="OK" />
      </Button>
    </div>
  </div>
)

export default Modal
